import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var _this = this;
import toast from '@mx/vix/toast';
import axios from 'axios';
import { env } from './env';
import { bridge } from './bridge';
import { EnvSecurityType } from "../common";
import { bizThenFunction, bizCatchFun } from './util';
export var mtHost = {
  prod: 'invoice.meituan.com',
  stage: 'invoicefe.fsp.st.meituan.com',
  test: 'invoicefe.fsp.test.meituan.com',
  test2: 'invoicefe-fsp.test.meituan.com',
  test3: 'invoicefe.fsp.test.sankuai.com',
  local: 'invoicefe-fsp.test.meituan.com',
  swimlane: location.host.includes("-sl-invoicefe.fsp.test.meituan.com") || location.host.includes("-sl-invoicefe.fsp.test.sankuai.com") ? location.host : 'invoicefe-fsp.test.meituan.com'
};
export var dpHost = {
  prod: 'invoice.dianping.com',
  stage: 'invoice.dianping.com',
  test: 'invoice2.51ping.com',
  test2: 'invoice2.51ping.com',
  local: 'invoice2.51ping.com',
  swimlane: location.host.includes("-sl-invoice2.51ping.com") ? location.host : 'invoice2.51ping.com'
};
var isDPHost = location.host.includes("51ping.com") || location.host.includes("dianping.com");
var host = isDPHost ? dpHost : mtHost;
export var appEnv = Object.keys(host).find(function (k) {
  return host[k] === location.host;
}) || 'local';
var serverUrl = function () {
  var HOST_MAP = {
    prod: host.prod + "/api/invoice",
    stage: host.stage + "/api/invoice",
    test: host.test + "/api/invoice",
    test2: host.test2 + "/api/invoice",
    test3: host.test3 + "/api/invoice",
    // local: '10.25.117.252:8080/api/invoice'
    local: host.test + "/api/invoice",
    swimlane: host.swimlane + "/api/invoice"
  };
  return location.protocol + "//" + HOST_MAP[appEnv || 'local'];
}();
var CustomError = /** @class */function (_super) {
  __extends(CustomError, _super);
  function CustomError(message, code) {
    var _this = _super.call(this, message) || this;
    _this.code = code || 0;
    return _this;
  }
  return CustomError;
}(Error);
export var http = function http(settings) {
  return __awaiter(_this, void 0, void 0, function () {
    var params, url;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          // loading提示
          // 默认显示 loading toast
          switch (settings.toastType) {
            case 'hide':
              break;
            case 'loading':
            default:
              toast.show('loading', settings.toastText);
          }
          return [4 /*yield*/, getParams(settings)];
        case 1:
          params = _a.sent();
          url = serverUrl + "/" + settings.url;
          return [2 /*return*/, axios({
            url: url,
            timeout: 50000,
            data: params,
            method: settings.method || 'post',
            withCredentials: true
          }).then(function (response) {
            innerSuccess(response.data, settings.toastType);
            if (response.data.code === 604) {
              bridge.login();
              return;
            }
            var bizOpts = {
              response: response,
              url: url,
              params: params
            };
            bizThenFunction(bizOpts, 200);
            return response.data || {};
          }).catch(function (error) {
            var bizCatchOpts = {
              params: params,
              error: error,
              url: url
            };
            bizCatchFun(bizCatchOpts);
            toast.hide();
            toast.show('text', '网络异常, 请检查您的网络设置');
          })];
      }
    });
  });
};
function getParams(settings) {
  return __awaiter(this, void 0, void 0, function () {
    var params, _a, _b, _c;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          params = settings.data || {};
          params.appChannel = env.appChannel;
          if (!settings.auth) return [3 /*break*/, 7];
          if (!env.accountSystem) return [3 /*break*/, 2];
          params.env = Number(env.accountSystem);
          _a = params;
          return [4 /*yield*/, env.getTokenAsync()];
        case 1:
          _a.identifyToken = _d.sent();
          return [3 /*break*/, 7];
        case 2:
          if (!(env.securityType === EnvSecurityType.weChat)) return [3 /*break*/, 3];
          params.env = 1;
          params.identifyToken = env.unionId;
          return [3 /*break*/, 7];
        case 3:
          if (!(env.securityType === EnvSecurityType.app)) return [3 /*break*/, 5];
          params.env = 2;
          _b = params;
          return [4 /*yield*/, env.getTokenAsync()];
        case 4:
          _b.identifyToken = _d.sent();
          return [3 /*break*/, 7];
        case 5:
          params.env = 3;
          _c = params;
          return [4 /*yield*/, env.getTokenAsync()];
        case 6:
          _c.identifyToken = _d.sent();
          _d.label = 7;
        case 7:
          return [2 /*return*/, params];
      }
    });
  });
}
// 请求成功回调函数
function innerSuccess(response, toastType) {
  if (!toastType || toastType === 'loading') {
    toast.hide();
  }
  if (!response) {
    throw new CustomError('网络异常, 请检查您的网络设置');
  }
}